import { LegacyOption } from './legacy-option';

export type Option<T> = {
  icon?: string | JSX.Element;
  id?: string;
  label: string;
  value: T;
};

export namespace Option {
  type FromConfig<T> = {
    labelKey?: keyof(T);
    valueKey?: keyof(T);
  };

  export function from<TItem, TValue>(
    items: TItem[],
    config: FromConfig<TItem>
  ): Option<TValue>[];
  export function from<TItem, TValue>(
    items: TItem[] | null | undefined,
    config: FromConfig<TItem>
  ): Option<TValue>[] | null | undefined;
  export function from<TItem, TValue>(
    items: TItem[] | null | undefined,
    {
      labelKey,
      valueKey
    }: FromConfig<TItem> = {}
  ): Option<TValue>[] | null | undefined {
    return items?.map((item): Option<TValue> => {
      return {
        label: ((labelKey) ? item[labelKey] : item) as string,
        value: ((valueKey) ? item[valueKey] : item) as TValue
      };
    });
  }

  export function fromLegacy<T>(
    oldOptions: LegacyOption<T>[]
  ): Option<T>[] {
    return Option.from(oldOptions, {
      labelKey: 'name',
      valueKey: 'value'
    });
  }

  export function toDropdownOptions<T extends number | string>(
    options: Option<T>[]
  ): Record<string, string> {
    return Object.fromEntries(options.map(({
      label,
      value
    }): [T, string] => {
      return [value, label];
    }));
  }
}
